import type { ForRuleProviding } from '../../../../evaluation/RulesProvider';
import { AcLineSegmentEvaluationEngine } from '../../../../evaluation/loadFlow/engines/lowVoltage/acLineSegment/acLineSegmentEvaluationEngine';
import { BusbarEvaluationEngine } from '../../../../evaluation/loadFlow/engines/lowVoltage/busbar/busbarEvaluationEngine';
import { EnergyConsumerEvaluationEngine } from '../../../../evaluation/loadFlow/engines/lowVoltage/energyConsumer/energyConsumerEvaluationEngine';
import { PowerTransformerEvaluationEngine } from '../../../../evaluation/loadFlow/engines/lowVoltage/powerTransformer/powerTransformerEvaluationEngine';
import type { ForAcLineSegmentEvaluation } from '../../../../evaluation/loadFlow/gridElements/acLineSegment/forAcLineSegmentEvaluation';
import type { ForBusbarEvaluation } from '../../../../evaluation/loadFlow/gridElements/busbar/forBusbarEvaluation';
import type { ForEnergyConsumerEvaluation } from '../../../../evaluation/loadFlow/gridElements/energyConsumer/forEnergyConsumerEvaluation';
import type { ForPowerTransformerEvaluation } from '../../../../evaluation/loadFlow/gridElements/powerTransformer/forPowerTransformerEvaluation';
import type { ForCreatingEvaluationEngines } from '../ForCreatingEvaluationEngines';

export class LowVoltageEvaluationEngineFactory
  implements ForCreatingEvaluationEngines
{
  constructor(private readonly rulesProvider: ForRuleProviding) {}

  createEnergyConsumerEvaluationEngine(): ForEnergyConsumerEvaluation {
    return new EnergyConsumerEvaluationEngine(this.rulesProvider);
  }

  createAcLineSegmentEvaluationEngine(): ForAcLineSegmentEvaluation {
    return new AcLineSegmentEvaluationEngine(this.rulesProvider);
  }

  createPowerTransformerEvaluationEngine(): ForPowerTransformerEvaluation {
    return new PowerTransformerEvaluationEngine(this.rulesProvider);
  }

  createBusbarEvaluationEngine(): ForBusbarEvaluation {
    return new BusbarEvaluationEngine(this.rulesProvider);
  }
}
